module.exports = __webpack_public_path__ + "static/media/ManageRequest.83bba39b.svg";